<nb-card>
  <nb-card-body>
    <div class="card-header">
      <span [class]="{ blur: loading }"> {{ label }}</span>
      <nb-icon
        [status]="change > -1 ? 'primary' : 'danger'"
        icon="{{ icon }}"
      ></nb-icon>
    </div>
    <div class="card-value" [nbSpinner]="loading">
      {{ loading ? 0 : formatFunction(value)
      }}<span class="unit"> {{ unit }}</span>
    </div>
    <div class="card-footer">
      <div *ngIf="change !== null || loading">
        <span
          class="badge"
          [ngClass]="{
            'badge-primary': change > -1,
            'badge-danger': change <= -1
          }"
          >{{ loading ? 0 : change }}%</span
        >
        <span [class]="{ blur: loading }">{{
          "charts.labels.vsBefore" | translate
        }}</span>
      </div>
    </div>
  </nb-card-body>
</nb-card>
